import React from 'react'
import { Knob } from '../instrument-knob/Knob'
import { Pad } from '../instrument-pad/Pad'
import { Toggle } from '../instrument-toggle/Toggle'
import { Fader } from '../instrument-fader/Fader'
import { Text } from '../instrument-text/Text'
import { Keys } from '../instrument-keys/Keys'
import { PianoKeyboard } from '../instrument-piano/PianoKeyboard'
import { BeginnerChordMachine } from '../instrument-chord/BeginnerChordMachine'



import Icon from '@ant-design/icons'
const EmptySvg = () => (
<svg width="1em" height="1em" viewBox="0 0 1024 1024">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill="#FFFFFF">
            <polygon points="252.584585 95.7084878 264.048016 90.7816741 310.974689 199.757752 299.511259 204.684566"></polygon>
            <polygon points="35.0220488 245.362341 43.7537717 236.435559 128.436074 319.556886 119.704351 328.483668"></polygon>
            <polygon points="505.262829 155.614985 517.750634 155.614985 517.750634 40.7371707 505.262829 40.7371707"></polygon>
            <polygon points="895.369366 320.189268 980.051668 237.067941 988.783391 245.994724 904.101089 329.116051"></polygon>
            <path d="M96.9240976,1018.48238 L336.677463,712.531122 C387.897444,732.53159 444.092566,745.019395 507.747902,745.019395 L509.016164,745.019395 C753.802115,745.019395 911.110993,555.217249 953.606993,497.748371 C954.875255,495.26055 954.875255,492.77273 953.606993,490.236207 C922.387481,445.260129 828.728944,326.620987 685.119188,267.940792 L882.438993,14.4758166 L872.439009,6.96365268 L672.634131,262.963653 C623.951672,244.231945 567.75655,233.012901 507.807594,233.012901 C261.810326,235.500722 108.197838,430.332706 66.9755941,491.497975 C65.7073327,493.985795 65.7073327,496.473616 66.9755941,499.010139 C105.70777,551.448929 194.338716,653.833943 324.24935,708.817748 L86.9810576,1012.28391 L96.9240976,1018.48238 Z M939.850927,493.994537 C894.874849,555.1648 742.531122,732.536585 507.747902,732.536585 L506.479641,732.536585 C446.528187,732.536585 392.820636,720.04878 342.864421,701.317073 L399.059543,630.146576 C430.279056,653.853424 469.011231,668.878751 510.181026,668.878751 C610.083465,668.878751 689.980441,587.70802 689.980441,489.079337 C689.980441,431.615454 662.51726,379.176663 620.028753,346.743337 L673.736304,278.06041 C814.96089,334.206829 907.395621,447.819629 939.838939,494.01202 L939.850927,493.994537 Z M344.195122,489.018896 C344.195122,396.62912 419.121951,321.707286 511.506732,321.707286 C545.213815,321.707286 577.702088,331.70727 603.896507,349.170466 L399.121483,612.638174 C365.4144,582.687422 344.195122,537.711344 344.195122,489.028886 L344.195122,489.018896 Z M615.168,356.623188 C655.118985,387.8427 680.094595,435.306349 680.094595,489.018896 C680.094595,581.408671 605.167766,656.330505 512.782985,656.330505 C474.05081,656.330505 437.856156,642.57394 409.124215,620.135852 L615.168,356.623188 Z M79.4661463,493.989042 C123.173463,431.550018 271.753366,246.718018 507.810341,245.5067 L511.566423,245.5067 C567.761545,245.5067 618.981526,256.726244 663.905155,272.969881 L612.685175,339.165237 C583.953233,320.43353 548.977389,309.214486 512.782736,309.214486 C412.880297,309.214486 332.983321,390.385218 332.983321,489.0139 C332.983321,541.452691 355.47136,588.91634 391.666014,622.620925 L332.983321,697.547754 C205.570248,645.108964 119.416882,547.694096 79.4661463,493.984047 L79.4661463,493.989042 Z"></path>
        </g>
    </g>
</svg>
)
const EmptyIcon = props => <Icon component={EmptySvg} {...props} />
export default class Instrument extends React.PureComponent {
  render() {
    
    const component = this.props.component
    
    const hash = window.location.hash
    const appName =  hash.replace(/^.{2}/g, '')
    const empty = (
      <div style={{
        width: '100%', 
        height: '100%', 
        border: '1px dotted rgba(0, 0, 0, 0.3)', 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '3em',
        mixBlendMode: 'difference'
        }}>
        <EmptyIcon/>
      </div>
    )

    // TODO: don't render instrument if the app doesn't allow it (can't load knob in #/manypads)
    // if component.name !== appName, return null

    if (component === 'Knob') {
      if ((appName === ('allthemidi')) || (appName === ('manyknobs'))) {
        return (
          <Knob
            bg={this.props.bg}
            bgactive={this.props.bgactive}
            channel={this.props.channel}
            defaultValue={this.props.defaultValue}
            direction={this.props.direction}
            idx={this.props.idx}
            key={'knob' + this.props.idx}
            note={this.props.note}
            text={this.props.text}
            value={this.props.value}
          />
        )
      } else {
        return empty
      }
    }
    if (component === 'Pad') {
      if ((appName === ('allthemidi')) || (appName === ('manypads'))) {return (
          <Pad
            bg={this.props.bg}
            bgactive={this.props.bgactive}
            channel={this.props.channel}
            defaultValue={this.props.defaultValue}
            idx={this.props.idx}
            key={'pad' + this.props.idx}
            note={this.props.note}
            text={this.props.text}
            value={this.props.value}
            velocity={this.props.velocity}
          />
        )
      } else {
        return empty
      }
    }
    if (component === 'Fader') {
      if ((appName === ('allthemidi')) || (appName === ('manyfaders'))) {
        return (
          <Fader
            bg={this.props.bg}
            bgactive={this.props.bgactive}
            channel={this.props.channel}
            defaultValue={this.props.defaultValue}
            direction={this.props.direction}
            idx={this.props.idx}
            key={'fader' + this.props.idx}
            note={this.props.note}
            text={this.props.text}
            value={this.props.value}
            width={this.props.w * 8}
            height={this.props.h * 8}
          />
        )
    } else {
      return empty
    }
    }
    if (component === 'Toggle') {
      if ((appName === ('allthemidi')) || (appName === ('manytoggles'))) {
        return (
          <Toggle
            bg={this.props.bg}
            bgactive={this.props.bgactive}
            channel={this.props.channel}
            defaultValue={this.props.defaultValue}
            idx={this.props.idx}
            key={'toggle' + this.props.idx}
            note={this.props.note}
            text={this.props.text}
            toggled={false}
            value={this.props.value}
          />
        )
    } else {
      return empty
    }
    }
    if (component === 'Keys') {
      if ((appName === ('allthemidi')) || (appName === ('manykeys'))) {
        return (
          <Keys
            store={this.props.store}
            key={'toggle' + this.props.idx}
            idx={this.props.idx}
            text={this.props.text}
            channel={this.props.channel}
            note={this.props.note}
            bg={this.props.bg}
            bgactive={this.props.bgactive}
            defaultValue={0}
          />
        )
    } else {
      return empty
    }
    }
    if (component === 'Text') {
      return (
        <Text
          bg={this.props.bg}
          bgactive={this.props.bgactive}
          channel={this.props.channel}
          defaultValue={this.props.defaultValue}
          idx={this.props.idx}
          key={'text' + this.props.idx}
          note={this.props.note}
          text={this.props.text}
          value={this.props.value}
        />
      )
    }
    if (component === 'hidden:piano') {
      return (
        <PianoKeyboard
          store={this.props.store}
          key={'toggle' + this.props.idx}
          idx={this.props.idx}
          text={this.props.text}
          channel={this.props.channel}
          note={this.props.note}
          bg={this.props.bg}
          bgactive={this.props.bgactive}
          defaultValue={0}
        />
      )
    }
    if (component === 'hidden:chords') {
      return (
        <BeginnerChordMachine
          store={this.props.store}
          key={'toggle' + this.props.idx}
          idx={this.props.idx}
          text={this.props.text}
          channel={this.props.channel}
          note={this.props.note}
          bg={this.props.bg}
          bgactive={this.props.bgactive}
          defaultValue={0}
        />
      )
    } else {
      return null
    }
  }
}
